import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { MuiTelInput } from "mui-tel-input";

function PhoneInput({ name, label }) {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: `${label} is required` }}
      render={({
        field: { onChange, ...restField },
        fieldState: { invalid, error },
      }) => (
        <MuiTelInput
          label={label}
          onChange={(event) => {
            onChange(event);
          }}
          defaultCountry="US"
          forceCallingCode
          onlyCountries={["US"]}
          error={invalid}
          helperText={error?.message}
          {...restField}
        />
      )}
    />
  );
}

export default PhoneInput;
